import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';

import Slide from '@swf/components/Inputs/Slide';

import {
  TXTWCL_N0_hr_4,
  TXTWCL_Time_limitX_N0_hours_N1_mins
} from './TimeLimitSlider.messages.json';
import { mark, markLabel, root } from './TimeLimitSlider.scss';

enum TimeLimit {
  Min = 0,
  Step = 30,
  Max = 480
}

interface TimeLimitOption {
  value: number;
  label?: React.ReactNode;
}

const timeLimitOptions: TimeLimitOption[] = new Array(TimeLimit.Max / TimeLimit.Step + 1)
  .fill({})
  .map((_, i) => ({
    value: TimeLimit.Step * i,
    ...(i % 2 === 0 && { label: <Translation {...TXTWCL_N0_hr_4} values={{ 0: i / 2 }} /> })
  }));

const TimeLimitSlider = () => {
  const {
    input: { value: timeLimit }
  } = useField('timeLimit');

  const hours = Math.floor(timeLimit / 60);
  const minutes = timeLimit % 60;

  return (
    <>
      <Translation
        tagName="div"
        {...TXTWCL_Time_limitX_N0_hours_N1_mins}
        values={{ 0: hours, 1: minutes }}
      />
      <Slide
        id="timeLimit"
        aria-label="Custom marks"
        defaultValue={TimeLimit.Min}
        step={TimeLimit.Step}
        marks={timeLimitOptions}
        min={TimeLimit.Min}
        max={TimeLimit.Max}
        classes={{ root, mark, markLabel }}
      />
    </>
  );
};

export default TimeLimitSlider;
